module.exports = __webpack_public_path__ + "img/1F1E8-1F1FB.a5e703b8.svg";